/* ===========================================================
   PRASINOUS - Charm quantity, stock, and the add to cart guard

   Quantity:
     tap a card        -> arms it, one "Add charm" button appears
     Add charm         -> adds one copy
     once added        -> [ - ] [ + ] [ See design ]
     top right badge   -> the slot numbers this charm occupies

   Limits, strictest wins:
     the block's "Max selectable charms"
     real stock, minus the cart, divided by the quantity selector
     engravable shapes are capped at one copy

   Add to cart guard:
     one press locks the button and fills a bar for as long as the
     request really takes, then confirms. Extra presses are swallowed.

   Base price on single variant products:
     the builder reads the base price from a variants JSON the theme
     only prints when there is a variant picker. A one variant product
     has no picker, so the totals box shows $0.00. We fetch the price
     and print that JSON ourselves, then let the builder recompute.

   Rendering is signature based so buttons are not rebuilt under a
   click in progress.
   =========================================================== */
(function () {
  'use strict';

  var SHAPES     = window.CP_ENGRAVE_SHAPES || {};
  var ENGRAVABLE = window.CP_ENGRAVE_ITEMS || {};

  var LOW_STOCK_AT = 2;
  var MIN_BUSY = 900, DONE_SHOWN = 2200, GIVE_UP = 12000;

  var FAMILY = (function () {
    var out = {};
    Object.keys(SHAPES).forEach(function (key) {
      var s = SHAPES[key], ids = [];
      if (s.one) ids.push(String(s.one));
      if (s.both) ids.push(String(s.both));
      ids.forEach(function (id) { out[id] = ids; });
    });
    return out;
  })();
  function familyOf(id) { return FAMILY[String(id)] || [String(id)]; }
  function isEngravable(id) { return !!ENGRAVABLE[String(id)]; }

  var COPY = {
    add: '+ Add charm', more: '+', less: '\u2212', see: 'See design \u2192',
    low: function (n) { return 'Only ' + n + ' left'; },
    guide: 'Tap a charm, then Add charm. Use + to add more than one.',
    adding: 'Adding your charm story\u2026',
    added: '\u2713 Your Charm Story is in your cart'
  };

  var CSS = [
    '.cpqOn .cpAddedBadge{ display:none !important; }',
    '.cpqOn .cp__item[data-cpq-gone="1"]{ display:none !important; }',
    '.cpqSlots{ position:absolute; top:4px; right:4px; z-index:2; display:inline-flex; align-items:center; justify-content:center;',
    '  min-width:18px; height:18px; padding:0 6px; border-radius:999px; font-size:9px; line-height:18px; font-weight:800; letter-spacing:.02em;',
    '  background:#143362; color:#fff; border:1px solid rgba(255,255,255,.25); pointer-events:none; user-select:none; }',
    '.cpqStock{ margin-top:4px; font-size:10px; line-height:1.2; font-weight:700; color:#9c3350; }',
    '.cpqBar{ display:flex; align-items:center; justify-content:center; gap:4px; flex-wrap:wrap; margin-top:6px; }',
    '.cpqBar[hidden]{ display:none !important; }',
    '.cpqBtn{ display:inline-flex; align-items:center; justify-content:center; padding:5px 9px; min-width:26px;',
    '  border:1px solid #143362; border-radius:999px; background:#fff; color:#143362; font-size:11px; line-height:1; font-weight:700;',
    '  cursor:pointer; white-space:nowrap; -webkit-tap-highlight-color:transparent; touch-action:manipulation;',
    '  transition: background-color 120ms ease, box-shadow 120ms ease; }',
    '.cpqBtn--add{ background:#143362; color:#fff; padding:6px 12px; }',
    '.cpqBtn--see{ background:#F3F3F3; padding:5px 10px; }',
    '.cpqBtn[disabled]{ opacity:.35; cursor:not-allowed; }',
    '@media (hover:hover) and (pointer:fine){ .cpqBtn:not([disabled]):hover{ box-shadow:0 4px 12px rgba(0,0,0,.12); } }',
    '.cpqBtn:focus-visible{ outline:2px solid rgba(37,32,88,.35); outline-offset:2px; }',
    '.cp__item.is-armed{ outline:1.5px solid rgba(37,32,88,.45); }',
    '@media (max-width: 640px){ .cpqBtn{ padding:5px 7px; min-width:24px; font-size:10px; } .cpqBtn--add{ padding:6px 10px; } .cpqBtn--see{ padding:5px 8px; } }',
    '.cpqOn .cpAddBtn{ position:relative; overflow:hidden; }',
    '.cpqOn .cpAddBtn .cpAddFill{ position:absolute; left:0; top:0; bottom:0; width:0; background:rgba(255,255,255,.22); pointer-events:none;',
    '  transition: width 2400ms cubic-bezier(.22,.61,.36,1); }',
    '.cpqOn .cpAddBtn.is-busy .cpAddFill{ width:88%; }',
    '.cpqOn .cpAddBtn.is-done .cpAddFill{ width:100%; background:rgba(110,245,142,.55); transition: width 220ms ease-out, background-color 220ms ease-out; }',
    '.cpqOn .cpAddBtn .cpAddLabel{ position:relative; }',
    '.cpqOn .cpAddBtn.is-busy, .cpqOn .cpAddBtn.is-done{ cursor:default; }',
    '.cpqOn .cpAddBtn.is-done{ background:#1f6b3a; border-color:#1f6b3a; }',
    '@media (prefers-reduced-motion: reduce){ .cpqOn .cpAddBtn .cpAddFill{ transition:none; } }'
  ].join('\n');

  (function injectCss() {
    if (document.getElementById('cpq-style')) return;
    var s = document.createElement('style'); s.id = 'cpq-style'; s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  })();

  /* ---------- cart contents ---------- */

  var inCart = {}, cartLoaded = false, onCartLoad = [];
  function loadCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var next = {};
        (cart.items || []).forEach(function (it) { var k = String(it.variant_id); next[k] = (next[k] || 0) + Number(it.quantity || 0); });
        inCart = next; cartLoaded = true;
        onCartLoad.forEach(function (fn) { try { fn(); } catch (e) {} });
      }).catch(function () { cartLoaded = true; });
  }
  loadCart();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) loadCart(); });

  var roots = [];

  function initRoot(root) {
    if (!root || root.dataset.cpqInit === '1') return;
    var api = root.cpApi;
    if (!api || !api.readSelected || !api.writeSelected) return;
    root.dataset.cpqInit = '1';
    root.classList.add('cpqOn');

    var armed = 0, rendering = false;

    var section = root.closest('section, .shopify-section');
    var form = (section && section.querySelector('form[action*="/cart/add"]')) || document.querySelector('form[action*="/cart/add"]');

    function unitQty() { var el = form && form.querySelector('[name="quantity"]'); return Math.max(1, Number(el && el.value || 1)); }
    function slots() { return api.readSelected().slots.slice(); }
    function titlesFor(s) {
      if (api.rebuildTitles) return api.rebuildTitles(s);
      var out = [];
      s.forEach(function (id) { if (!id) return; var b = root.querySelector('[data-charm-item][data-variant-id="' + id + '"]'); if (b) out.push((b.dataset.title || '').trim()); });
      return out;
    }
    function slotNumbers(id) {
      var fam = familyOf(id), s = slots(), out = [];
      for (var i = 0; i < s.length; i++) if (fam.indexOf(String(s[i])) > -1) out.push(i + 1);
      return out;
    }
    function hasRoom() { return slots().indexOf(0) > -1; }
    function copyCap(card, id) {
      if (isEngravable(id)) return 1;
      var tracked = String(card.dataset.cpTrack || '') !== '';
      var policy = String(card.dataset.cpPolicy || '');
      if (!tracked || policy === 'continue') return Infinity;
      var free = Number(card.dataset.cpStock || 0) - Number(inCart[String(id)] || 0);
      if (free <= 0) return 0;
      return Math.floor(free / unitQty());
    }
    function commit(s) { api.writeSelected(s, titlesFor(s)); render(); }
    function addOne(card, id) {
      var s = slots(), i = s.indexOf(0);
      if (i === -1) return;
      if (slotNumbers(id).length >= copyCap(card, id)) return;
      s[i] = id; commit(s);
    }
    function removeOne(id) {
      var fam = familyOf(id), s = slots();
      for (var i = s.length - 1; i >= 0; i--) if (fam.indexOf(String(s[i])) > -1) { s[i] = 0; break; }
      commit(s);
    }
    function goToPreview() { window.scrollTo({ top: 0, behavior: 'smooth' }); }

    /* ---- base price for single variant products ---- */

    (function ensureVariantJson() {
      var container = section || document;
      var idEl = form && form.querySelector('[name="id"]');
      var baseId = Number(idEl && idEl.value || 0);
      if (!baseId) return;

      var found = Array.prototype.slice.call(container.querySelectorAll('script[type="application/json"]')).some(function (s) {
        try {
          var p = JSON.parse(s.textContent || '');
          var arr = Array.isArray(p) ? p : (p && p.variants);
          return Array.isArray(arr) && arr.some(function (v) { return Number(v.id) === baseId && typeof v.price === 'number'; });
        } catch (e) { return false; }
      });
      if (found) return;

      var handle = String(root.dataset.cpProfile || '').trim();
      if (!handle) return;

      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (!p || !Array.isArray(p.variants)) return;
          var s = document.createElement('script');
          s.type = 'application/json';
          s.setAttribute('data-cpq-variants', '1');
          s.textContent = JSON.stringify({ variants: p.variants.map(function (v) { return { id: v.id, price: v.price }; }) });
          (section || root).appendChild(s);
          var st = api.readSelected();
          api.writeSelected(st.slots, titlesFor(st.slots));   /* builder recomputes totals */
        })
        .catch(function () {});
    })();

    function mkBtn(cls, label, action, disabled, aria) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cpqBtn' + (cls ? ' ' + cls : '');
      b.setAttribute('data-cpq', action); b.textContent = label;
      if (aria) b.setAttribute('aria-label', aria);
      if (disabled) b.setAttribute('disabled', 'disabled');
      return b;
    }

    function renderCard(card) {
      if (card.hasAttribute('data-cpe-twin')) return;
      var id = Number(card.dataset.variantId || 0); if (!id) return;
      var meta = card.querySelector('.cp__meta'); if (!meta) return;

      var engravable = isEngravable(id);
      var nums = slotNumbers(id), cap = copyCap(card, id);
      var soldOut = card.hasAttribute('disabled');
      var left = cap === Infinity ? Infinity : Math.max(0, cap - nums.length);
      var gone = !soldOut && cap !== Infinity && cap <= 0 && nums.length === 0;
      var isArmed = !nums.length && armed === id && !gone;
      var allowMore = hasRoom() && left > 0;
      var lowNote = (!engravable && cap !== Infinity && left > 0 && left <= LOW_STOCK_AT) ? COPY.low(left) : '';

      var sig = [nums.join(','), soldOut ? 1 : 0, gone ? 1 : 0, isArmed ? 1 : 0, allowMore ? 1 : 0, lowNote].join('|');
      if (card.dataset.cpqSig === sig) return;
      card.dataset.cpqSig = sig;

      if (gone) { card.setAttribute('data-cpq-gone', '1'); return; }
      card.removeAttribute('data-cpq-gone');
      card.classList.toggle('is-armed', isArmed);

      var badge = card.querySelector('.cpqSlots');
      if (nums.length) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cpqSlots'; card.appendChild(badge); }
        badge.textContent = nums.length > 3 ? nums.slice(0, 3).join(',') + ',+' + (nums.length - 3) : nums.join(',');
      } else if (badge) badge.remove();

      var note = meta.querySelector('.cpqStock');
      if (lowNote) {
        if (!note) { note = document.createElement('div'); note.className = 'cpqStock'; meta.appendChild(note); }
        if (note.textContent !== lowNote) note.textContent = lowNote;
      } else if (note) note.remove();

      var bar = meta.querySelector('.cpqBar');
      if (!bar) { bar = document.createElement('div'); bar.className = 'cpqBar'; meta.appendChild(bar); }
      bar.innerHTML = '';
      if (soldOut) { bar.hidden = true; return; }

      if (nums.length) {
        bar.hidden = false;
        bar.appendChild(mkBtn('', COPY.less, 'minus', false, 'Remove one'));
        if (!engravable) bar.appendChild(mkBtn('', COPY.more, 'add', !allowMore, 'Add another'));
        bar.appendChild(mkBtn('cpqBtn--see', COPY.see, 'see', false, null));
      } else if (isArmed) {
        bar.hidden = false;
        bar.appendChild(mkBtn('cpqBtn--add', COPY.add, 'add', !allowMore, null));
      } else bar.hidden = true;
    }

    function render() {
      if (rendering) return;
      rendering = true;
      try { root.querySelectorAll('[data-charm-item]').forEach(renderCard); } finally { rendering = false; }
    }
    function repaintAll() {
      root.querySelectorAll('[data-charm-item]').forEach(function (c) { delete c.dataset.cpqSig; });
      render();
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-charm-item]');
      if (!card || !root.contains(card)) return;
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (card.hasAttribute('disabled')) return;
      var id = Number(card.dataset.variantId || 0); if (!id) return;
      var ctl = e.target.closest('[data-cpq]');
      if (ctl) {
        if (ctl.hasAttribute('disabled')) return;
        var act = ctl.getAttribute('data-cpq');
        if (act === 'add') { armed = 0; addOne(card, id); }
        else if (act === 'minus') removeOne(id);
        else if (act === 'see') goToPreview();
        return;
      }
      if (slotNumbers(id).length) return;
      armed = (armed === id) ? 0 : id;
      render();
    }, true);

    if (form) {
      form.addEventListener('change', function (e) {
        var n = e.target && e.target.getAttribute && e.target.getAttribute('name');
        if (n === 'quantity' || n === 'id') repaintAll();
      }, true);
    }
    onCartLoad.push(repaintAll);

    var pending = null;
    new MutationObserver(function () {
      if (rendering || pending) return;
      pending = setTimeout(function () { pending = null; render(); }, 60);
    }).observe(root, { childList: true, subtree: true });

    var guide = root.querySelectorAll('.cpStoryGuide__line');
    if (guide && guide.length > 1) guide[1].textContent = '2. ' + COPY.guide;

    /* ---- add to cart guard ---- */

    var addBtn = root.querySelector('[data-cp-add]');
    if (addBtn && !addBtn.querySelector('.cpAddLabel')) {
      var originalLabel = addBtn.textContent.trim();
      addBtn.textContent = '';
      var fill = document.createElement('span'); fill.className = 'cpAddFill';
      var label = document.createElement('span'); label.className = 'cpAddLabel'; label.textContent = originalLabel;
      addBtn.appendChild(fill); addBtn.appendChild(label);

      var busy = false, startedAt = 0, giveUpTimer = null, doneTimer = null;
      function setLabel(t) { if (label.textContent !== t) label.textContent = t; }
      function lock() {
        busy = true; startedAt = Date.now();
        addBtn.classList.remove('is-done'); addBtn.classList.add('is-busy');
        addBtn.setAttribute('aria-busy', 'true'); setLabel(COPY.adding);
        if (giveUpTimer) clearTimeout(giveUpTimer);
        giveUpTimer = setTimeout(function () { unlock(false); }, GIVE_UP);
      }
      function unlock(success) {
        if (giveUpTimer) { clearTimeout(giveUpTimer); giveUpTimer = null; }
        if (doneTimer) { clearTimeout(doneTimer); doneTimer = null; }
        busy = false; addBtn.removeAttribute('aria-busy');
        if (!success) { addBtn.classList.remove('is-busy', 'is-done'); setLabel(originalLabel); return; }
        addBtn.classList.remove('is-busy'); addBtn.classList.add('is-done'); setLabel(COPY.added);
        doneTimer = setTimeout(function () { addBtn.classList.remove('is-done'); setLabel(originalLabel); loadCart(); }, DONE_SHOWN);
      }
      function finish() {
        if (!busy) return;
        var wait = Math.max(0, MIN_BUSY - (Date.now() - startedAt));
        setTimeout(function () { unlock(true); }, wait);
      }
      root.addEventListener('click', function (e) {
        if (!e.target.closest('[data-cp-add]')) return;
        if (busy) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); return; }
        if (!api.readSelected().ids.length) return;
        lock();
      }, true);
      ['cart:open', 'theme:cart:open'].forEach(function (n) { document.addEventListener(n, finish); });
      var nativeAlert = window.alert;
      window.alert = function () { if (busy) unlock(false); return nativeAlert.apply(window, arguments); };
    }

    render();
    if (cartLoaded) repaintAll();
    roots.push(root);
  }

  function initAll() { document.querySelectorAll('[data-charm-picker][data-cp-mode="multi"]').forEach(initRoot); }
  function boot() {
    initAll();
    var tries = 0;
    var timer = setInterval(function () { initAll(); if (++tries > 40 || roots.length) clearInterval(timer); }, 100);
    document.addEventListener('shopify:section:load', initAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

})();